import Vue from 'vue';
import App from './App';
import Router from './router';
import store from './services/store.js';
import CommonPlugin from './CommonPlugin';
import VueMeta from 'vue-meta';
import ElementUI from 'element-ui';
import VueGtm from 'vue-gtm';
import ResourceSvc from '@/services/resource.svc.js';
const srcSvc = new ResourceSvc();
import 'element-ui/lib/theme-chalk/index.css';
import LightBootstrap from './components/theme/light-bootstrap-main';

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(LightBootstrap);
Vue.use(CommonPlugin);
Vue.use(VueMeta);

Vue.use(VueGtm, {
    id: 'GTM-PTF72B5', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
      gtm_auth: 'cod682p4TUHo5t2tAYhxFw',
      gtm_preview:'env-1',
      gtm_cookies_win:'x'
    },
    defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: Router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: ['homepage'], // Don't trigger events for specified router names (case insensitive) (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  });

Router.beforeEach(
    (to, from, next) => {
        var rule = to.meta.rule;
        if (!rule)
            rule = [];
        if (rule.some(function (el) { return el === "Any"; })) {
            next();
            return;
        }

        var user = store.getters.getCurrentUser;

        if (user && user.id) {
            user.roles.forEach(function (role) {
                if (rule.some(function (el) { return el === role; }))
                    next();
                return;
            });
        }
        else {
            let getUserPromise = new Promise((resolve, reject) => {
                srcSvc.getCurrentUserShotInfo()
                    .then(function (res) { resolve(res); })
                    .catch(function (err) { reject(err); });

            });

            getUserPromise
                .then(
                    res => {
                        var redirectTologin = '';
                        if (to.path.toLowerCase().indexOf('admin') >= 0) {
                            redirectTologin = process.env.url.manegementLogin;
                        }
                        else {
                            redirectTologin = process.env.url.oldAppLogin;
                        }
                      
                        var user = res.body;
                        if (!user || user === null || !user.id) {
                            window.location = redirectTologin;
                        }
                        else {
                            store.commit('setCurrentUser', user);
                            user.roles.forEach(function (role) {
                                if (rule.some(function (el) { return el === role; })) {
                                    next();
                                    return;
                                }
                                else {
                                    window.location = redirectTologin;
                                }
                            });
                        }
                    },
                    error => {
                        var redirectTologin = '';
                        if (to.path.toLowerCase().indexOf('admin') >= 0) {
                            redirectTologin = process.env.url.manegementLogin;
                        }
                        else {
                            redirectTologin = process.env.url.oldAppLogin;
                        }
                        window.location = redirectTologin;
                    }
                );
        }
    }
);
/*
App.use(createGtm({
    id: 'GTM-PTF72B5',  // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
      gtm_auth:'cod682p4TUHo5t2tAYhxFw',
      gtm_preview:'env-4',
      gtm_cookies_win:'x'
    },
    defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: Router, // Pass the router instance to automatically sync with router (optional)
    //ignoredViews: ['homepage'], // Don't trigger events for specified router names (case insensitive) (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  }));
  */

new Vue({
    el: '#app',
    router: Router,
    store,
    beforeCreate() {
        var user = store.getters.getCurrentUser;
        if (!user || !user.id)
            srcSvc.getCurrentUserShotInfo()
                .then(function (res) {
                    if (res.body && res.body.id) {
                        store.commit('setCurrentUser', res.body);
                    }
                    else {
                        store.commit('setCurrentUser', null);
                    }
                })
                .catch(function (err) { store.commit('setCurrentUser', null); });
    },
    render: h => h(App)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js